// The application's root component.
//
// NOT named App.js: macOS and Windows filesystems are case-insensitive, so
// `App.js` and `app.js` are the same file — writing one silently destroys the
// other. On Linux they would be two files, so the bug would appear only on some
// machines. AppRoot keeps it unambiguous everywhere.
//
// Extracted from bootstrap.js for Vue 3: createApp takes the root component as
// its argument, so the component must exist before the app is configured — the
// inverse of Vue 2, where the global constructor was configured first and the
// root built from it with Vue.extend.
//
// router and store were component options here under Vue 2. In Vue 3 they are
// installed on the app instance instead; see bootstrap.js. (An apolloProvider
// sat alongside them until it was removed as dead code -- nothing queried it.)
import { h, resolveComponent } from 'vue'
import { mapActions, mapGetters } from 'vuex'
import ModalTermsAcceptanceReminder from 'app/views/accounts/AccountView/Settings/ModalTermsAcceptanceReminder'

export default {
  name: 'App',
  components: {
    ModalTermsAcceptanceReminder
  },
  // Vue 3 render shape: `h` is imported rather than passed in, props/attrs/
  // listeners are one flat object (`onDrop`, not `on: { drop }`), and globally
  // registered components must go through `resolveComponent` — a bare string
  // tag would emit a literal <router-view> element instead of resolving.
  render() {
    const preventDefault = (event) => event.preventDefault()

    return h(
      'div',
      { id: 'vue-container', onDrop: preventDefault, onDragover: preventDefault },
      [
        h(resolveComponent('router-view')),
        h(resolveComponent('dashboard')),
        h(ModalTermsAcceptanceReminder, { isShowing: this.shouldShowTermsReminder })
      ]
    )
  },
  computed: {
    ...mapGetters('termsAcceptance', ['needsTermsAcceptance']),
    isInTermsExclusionRoute() {
      const path = (this.$route && this.$route.path) || ''
      const blocked = ['/start/confirm', '/account/set-password', '/account/personal-info']

      return blocked.some((blockedPath) => path.startsWith(blockedPath))
    },

    accountPresenceKey() {
      const account = this.$account

      if (!account || account.id == null) {
        return 'no-account'
      }

      const accepted = account.termsAcceptedAt || 'null'
      return `${account.id}-${accepted}`
    },

    shouldShowTermsReminder() {
      const account = this.$account || {}
      const hasAccount = account && account.id != null

      if (!hasAccount) {
        return false
      }

      if (this.isInTermsExclusionRoute) {
        return false
      }

      return this.needsTermsAcceptance
    }
  },
  watch: {
    accountPresenceKey: {
      immediate: true,
      handler() {
        this.evaluateTermsAcceptance({ account: this.$account })
      }
    }
  },
  methods: {
    ...mapActions('termsAcceptance', { evaluateTermsAcceptance: 'evaluate' })
  }
}
